module.exports = __webpack_public_path__ + "img/white-block-right.439a0bfa.png";